<template>
    <div class="animated fadeIn">
        <loading :active.sync="disabledField"></loading>
        <notifications group="foo" />
        <b-row class="text-right">
            <b-col cols="6" sm="4" md="2" class="mb-3">
                <b-button size="sm" block v-bind:variant="btnConnectClass()" v-on:click="changeWidgetStatus()" :disabled="btnChangeDisabled()">{{btnConnectText()}}</b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="6">
                <b-card>
                    <div slot="header">
                        <b-row >
                            <b-col cols="6" sm="6" md="6">
                                <i class="fa fa-edit"></i><strong> Формулы</strong> 
                            </b-col>
                            <b-col cols="6" sm="6" md="6" class="text-right">
                                <b-button type="submit" right size="sm" variant="" v-on:click="addFormula()"><i class="fa fa-plus"></i> Добавить формулу</b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div>
                        <b-row class="mb-3" v-for="item in settings">
                            <b-col md="3"><b-form-select :options="amoLeadFields" v-model="item.field"></b-form-select></b-col>
                            <b-col md="7">
                                <vue-tribute :options="options">
                                    <input type="text" placeholder="Формула" v-bind:value="item.formula" v-on:change="item.formula= $event.target.value"/>
                                </vue-tribute>
                            </b-col>
                            <b-col md="2">
                                <b-button right size="sm" variant="danger" v-on:click="removeFormula(item)"><i class="fa fa-minus"></i></b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div slot="footer">
                        <b-button type="submit" :disabled="!widget.isActive" size="sm" variant="primary" v-on:click="saveSettings()"><i class="fa fa-save"></i> Сохранить</b-button>
                    </div>
                </b-card>
            </b-col>

            <b-col md="6">
                <b-card header-tag="header" footer-tag="footer">
                    <div slot="header"> <i class="icon-notebook icons"></i><strong> Описание</strong></div>
                    <p>Обещали, что CRM умнее чем Эксель, но она банально не может суммировать пару цифр? Виджет "Калькулятор" устраняет это недоразумение. Прописываете в настройках формулу и вот уже часть данных заполняется автоматически.</p>
                </b-card>
            </b-col>
        </b-row>
  </div>
</template>

<script>
    import WidgetsService from '@/services/WidgetsService'
    import widgetEvents from '@/views/widgets/Widget';
    import VueTribute from 'vue-tribute'

    export default {
        mixins: [
            widgetEvents
        ],
        components: { VueTribute }, 
        name: 'Calc',
        data () {
            return {
                widget: { isActive : false },
                widgetId: '5ceb7e0f1e5bb52e19d4ff99',
                amoLeadFields : [],
                settings: [],
                disabledField: false,
                onLoad: false,
                options : {
                    trigger: '@',
                    values: [],
                    lookup: 'value',
                    replaceTextSuffix: '@ '
                }
            }
        },
        computed: {

        },
        created: function () {
            this.getWidget(() => {
                this.getLeadFields();
            });
        },
        methods: {
            async getLeadFields () {
                this.disabledField = true;                
                await WidgetsService.getLeadFields([2]).then(response => {                    
                    this.amoLeadFields = response.data.result;
                    this.amoLeadFields.push({text: 'Бюджет', value : '0'});
                    console.log(this.amoLeadFields)
                    for(let i=0; i <= this.amoLeadFields.length - 1; i++){ this.options.values.push({value: this.amoLeadFields[i].text}); }                    
                    this.disabledField = false;

                }).catch(err => { return console.log(err); });
            },
            addFormula : function (){
                this.settings.push({ field: '0', formula: '' });
            },
            removeFormula(item) {
                this.settings.splice(this.settings.indexOf(item), 1);
                this.saveSettings();
            },
        },
    };
    
</script>

<style>
.v-tribute {
  width: 100%;
}
input[type='text'],
.content-editable {
  appearance: none;
  border: none;
  background: #eee;
  padding: 0.5rem 0.25rem;
  color: #666;
  width: 100%;
  border-radius: 0.25rem;
  font-size: 13px;
  outline: none;
  &:focus {
    background: #fff;
  }
}
.content-editable:empty:before {
  content: attr(placeholder);
  display: block;
  color: #666;
}
textarea {
  appearance: none;
  border: none;
  background: #eee;
  padding: 1rem;
  width: 100%;
  border-radius: 0.25rem;
  font-size: 16px;
  height: 100px;
  outline: none;
  &:focus {
    background: #fff;
  }
}
.tribute-container {
  position: absolute;
  top: 0;
  left: 0;
  height: auto;
  max-height: 300px;
  max-width: 500px;
  overflow: auto;
  display: block;
  z-index: 999999;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(#000, 0.13);
}
.tribute-container ul {
  margin: 0;
  margin-top: 2px;
  padding: 0;
  list-style: none;
  background: #fff;
  border-radius: 4px;
  border: 1px solid rgba(#000, 0.13);
  background-clip: padding-box;
  overflow: hidden;
}
.tribute-container li {
  color: #3f5efb;
  padding: 5px 10px;
  cursor: pointer;
  font-size: 14px;
}
.tribute-container li.highlight,
.tribute-container li:hover {
  background: #3f5efb;
  color: #fff;
}
.tribute-container li span {
  font-weight: bold;
}
.tribute-container li.no-match {
  cursor: default;
}
.tribute-container .menu-highlighted {
  font-weight: bold;
}
</style>